import { Props, Select, SelectInstance, type GroupBase } from 'chakra-react-select';
import { ForwardedRef, ReactElement, RefAttributes, forwardRef } from 'react';

// Styling for this happens with index.css and targeting with className
// because Chakra style customizations don't seem to work for the third party chakra react select component
export const resistomapSelectClassNamePrefix = 'resistomap-select';

type Option = { label: unknown; value: unknown };

type ResistomapSelectComponent = <T extends Option, IsMulti extends boolean, Group extends GroupBase<T> = GroupBase<T>>(
  props: Props<T, IsMulti, Group> & RefAttributes<SelectInstance<T, IsMulti, Group>>,
) => ReactElement;

const ResistomapSelectInner = <T extends Option, IsMulti extends boolean, Group extends GroupBase<T> = GroupBase<T>>(
  props: Props<T, IsMulti, Group>,
  ref: ForwardedRef<SelectInstance<T, IsMulti, Group>>,
) => <Select {...props} ref={ref} classNamePrefix={resistomapSelectClassNamePrefix} />;

ResistomapSelectInner.displayName = 'ResistomapSelect';

export const ResistomapSelect = forwardRef(ResistomapSelectInner) as ResistomapSelectComponent;
